import { ConfigManager } from '../utils/configManager';
/**
 * Dynamic configuration that checks multiple sources in priority order:
 * 1. Control Panel settings (localStorage)
 * 2. Environment variables
 * 3. Default values
 */
class DynamicConfig {
    constructor() {
        this.cachedConfig = null;
        this.listeners = [];
    }
    /**
     * Get the current configuration with priority system
     * Priority order:
     * 1. Environment variables (.env file) - highest priority
     * 2. Control Panel settings (localStorage)
     * 3. Default values
     */
    getConfig() {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
        const savedConfig = ConfigManager.loadConfig();
        const apiKeys = (savedConfig === null || savedConfig === void 0 ? void 0 : savedConfig.search.apiKeys) || {};
        // Priority: Environment variables > Control Panel > Defaults
        return {
            // Provider: env var takes priority
            provider: ((_a = process.env.PROVIDER) === null || _a === void 0 ? void 0 : _a.toLowerCase()) || (savedConfig === null || savedConfig === void 0 ? void 0 : savedConfig.search.provider) || 'mock',
            mockPlatform: (savedConfig === null || savedConfig === void 0 ? void 0 : savedConfig.search.mockPlatform) || 'algolia',
            algolia: {
                appId: process.env.ALGOLIA_APP_ID || ((_b = apiKeys.algolia) === null || _b === void 0 ? void 0 : _b.appId) || '',
                apiKey: process.env.ALGOLIA_API_KEY || ((_c = apiKeys.algolia) === null || _c === void 0 ? void 0 : _c.apiKey) || '',
                indexName: process.env.ALGOLIA_INDEX || ((_d = apiKeys.algolia) === null || _d === void 0 ? void 0 : _d.indexName) || '',
                suggestionsIndex: process.env.ALGOLIA_SUGGESTIONS_INDEX || '',
            },
            shopify: {
                domain: process.env.SHOPIFY_STORE_DOMAIN || ((_e = apiKeys.shopify) === null || _e === void 0 ? void 0 : _e.domain) || '',
                storefrontToken: process.env.SHOPIFY_STOREFRONT_ACCESS_TOKEN || ((_f = apiKeys.shopify) === null || _f === void 0 ? void 0 : _f.storefrontToken) || '',
            },
            unbxd: {
                endpoint: process.env.UNBXD_ENDPOINT || 'https://search.unbxd.io',
                siteKey: process.env.UNBXD_SITE_KEY || ((_g = apiKeys.unbxd) === null || _g === void 0 ? void 0 : _g.siteKey) || '',
                apiKey: process.env.UNBXD_API_KEY || ((_h = apiKeys.unbxd) === null || _h === void 0 ? void 0 : _h.apiKey) || '',
            },
            boost: {
                apiUrl: process.env.BOOST_API_URL || ((_j = apiKeys.boost) === null || _j === void 0 ? void 0 : _j.apiUrl) || '',
                shop: process.env.BOOST_SHOP || ((_k = apiKeys.boost) === null || _k === void 0 ? void 0 : _k.shop) || '',
            },
            searchspring: {
                siteId: process.env.SEARCHSPRING_SITE_ID || ((_l = apiKeys.searchspring) === null || _l === void 0 ? void 0 : _l.siteId) || '',
            },
        };
    }
    /**
     * Update configuration from Control Panel
     */
    updateConfig(config) {
        ConfigManager.saveConfig(config);
        this.cachedConfig = config;
        this.notifyListeners(config);
    }
    /**
     * Subscribe to configuration changes
     */
    subscribe(listener) {
        this.listeners.push(listener);
        return () => {
            this.listeners = this.listeners.filter(l => l !== listener);
        };
    }
    notifyListeners(config) {
        this.listeners.forEach(listener => listener(config));
    }
}
export const dynamicConfig = new DynamicConfig();
